import React from 'react';
export function Hero() {
  return <section className="bg-hero-gradient text-center pt-[60px] pb-[50px] px-5 border-b border-divider" data-id="element-81">
      <div className="text-[13px] tracking-[4px] text-gold font-bold mb-2 uppercase" data-id="element-82">
        <span className="text-gold text-xl mx-1.5" data-id="element-83">✝</span> MISIÓN INFLUENCIA™{' '}
        <span className="text-gold text-xl mx-1.5" data-id="element-84">✝</span>
      </div>

      <h1 className="text-2xl md:text-4xl lg:text-[42px] font-black leading-tight text-text-heading mb-5 max-w-[700px] mx-auto" data-id="element-85">
        ¿Tenés fe pero no sabés cómo compartirla sin sonar{' '}
        <span className="text-gold" data-id="element-86">predicador, invasivo o raro?</span>
      </h1>

      <p className="text-[15px] md:text-lg text-text-muted max-w-[580px] mx-auto mb-[30px] leading-relaxed" data-id="element-87">
        El sistema completo para que el cristiano moderno evangelice en
        Instagram de forma natural, estratégica y con impacto real. Sin miedo al
        rechazo. Sin perder seguidores.
      </p>

      <div className="flex flex-wrap justify-center gap-2.5 mb-[30px]" data-id="element-88">
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-89">
          ✝️ 100% PDF
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-90">
          ⚡ Acceso en 5 min
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-91">
          🇦🇷 Para cristianos argentinos
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-92">
          📚 6 Tomos + 5 Bonos
        </span>
      </div>

      <a href="https://www.stockdigital.shop/checkouts/cn/hWNC0JGtZ4UXGzFFtqS60pr0/es-ar?_r=AQABgqRKz8X0FzFMzgg2iw3bFO43mKzRGrYWJsB1MM2QPv4&cart_link_id=vPJR0qhR&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold-gradient text-base font-black text-[17px] py-[18px] px-9 rounded-full no-underline mb-4 shadow-[0_4px_20px_rgba(201,168,76,0.4)] transition-transform duration-200 hover:scale-[1.03]" data-id="element-93">
        🔥 QUIERO MI MISIÓN INFLUENCIA AHORA
      </a>

      <div className="text-xs text-[#888] mb-6 flex justify-center flex-wrap gap-4" data-id="element-94">
        <span data-id="element-95">✅ Garantía 7 días</span>
        <span data-id="element-96">🔒 Pago seguro</span>
        <span data-id="element-97">💳 Mercado Pago</span>
      </div>

      <div className="flex flex-wrap justify-center gap-4 text-[13px] text-gold font-bold" data-id="element-98">
        <span data-id="element-99">+800 cristianos</span>
        <span data-id="element-100">·</span>
        <span data-id="element-101">6 Tomos</span>
        <span data-id="element-102">·</span>
        <span data-id="element-103">5 Bonos</span>
        <span data-id="element-104">·</span>
        <span data-id="element-105">⭐ 4.9/5</span>
      </div>
    </section>;
}